/*
 *
 * Copyright (C) 2021 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import PropTypes from 'prop-types'
import { Donut } from '@netbasequid/chart'
import React from 'react'
import { useDisplayTheme } from '../../../hooks/useUiState'

const DonutChart = ({
  data,
  colorSettings,
  seriesName,
  showDataLabel,
  showLegend,
  trackThickness,
  size,
  centerSection,
  onClick
}) => {
  const theme = useDisplayTheme()

  return (
    <Donut
      data={data}
      legendPosition="bottom"
      mode={theme}
      colorSettings={colorSettings}
      showLegend={showLegend}
      seriesName={seriesName}
      showDataLabel={showDataLabel}
      trackThickness={trackThickness}
      size={size}
      centerSection={centerSection}
      onClick={onClick}
    />
  )
}

DonutChart.defaultProps = {
  colorSettings: {},
  seriesName: '',
  showDataLabel: true,
  // NI-2503: existing consumers (SourceDonut etc.) keep the outer-label layout
  // unchanged. Per-widget consumers like the Sentiment widget opt into the
  // built-in legend by passing `showLegend` so the slice labels render inside
  // the chart's plot box and can't overflow the panel.
  showLegend: false,
  trackThickness: 40,
  size: null,
  centerSection: {
    type: undefined,
    title: '',
    value: 0,
    valueFormatter: (value) => `${value}`,
    deltaValue: undefined,
    deltaValueFormatter: (value) => `${Math.abs(value)}`
  },
  onClick: undefined
}
DonutChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      y: PropTypes.number,
      isBreak: PropTypes.bool,
      chartBreakTooltipContent: PropTypes.string
    })
  ).isRequired,
  colorSettings: PropTypes.objectOf(PropTypes.string),
  seriesName: PropTypes.string,
  showDataLabel: PropTypes.bool,
  showLegend: PropTypes.bool,
  trackThickness: PropTypes.number,
  size: PropTypes.string,
  centerSection: PropTypes.shape({
    type: PropTypes.oneOf(['summary']),
    title: PropTypes.string,
    value: PropTypes.number,
    valueFormatter: PropTypes.func,
    deltaValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    deltaValueFormatter: PropTypes.func,
    deltaDirection: PropTypes.oneOf(['up', 'down', 'none'])
  }),
  onClick: PropTypes.func
}

export default DonutChart
